import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser';

// ── MSAL Browser configuration ────────────────────────────────────────────────
// Client ID and Tenant ID are safe to expose in the frontend —
// they identify the app but cannot be used to act without user consent.
// The actual auth happens via Microsoft's servers; no secrets live here.

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    // Redirect URI must match exactly what's registered in Azure AD as a SPA redirect URI
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii || import.meta.env.PROD) return;
        if (level === LogLevel.Error) console.error('[MSAL]', message);
      },
    },
  },
};

// Scopes needed: User.Read lets us identify the user;
// the Worker validates the token by calling Graph /me
export const LOGIN_SCOPES = [
  'https://graph.microsoft.com/User.Read',
  'https://graph.microsoft.com/Mail.Read',
];

export const msalInstance = new PublicClientApplication(msalConfig);
